import { createFileRoute } from "@tanstack/react-router";

import TcAuth from "@/features/auth/TcAuth";
import BasicLayout from "@/layouts/Basic";

export const Route = createFileRoute("/tcauth")({
  component: () => (
    <BasicLayout>
      <TcAuth />
    </BasicLayout>
  ),
});
